"use client";

import React from "react";
import { Provider } from "react-redux";
import { store } from "@redux/store";
import { storeV1Context } from "@redux/hooks";

export default function ReduxProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store} context={storeV1Context}>
      {children}
    </Provider>
  );
}
